<template>
  <qc-container title="银行卡管理" :show-return="true">
    <page-request  ref="table" url="/api/mgr/business/shop/money/info/bankList" :table-header="tableHeader" :expend="expend" :prop="{goodsType:0}" :op-width="200">
      <t-button @click="editBank('')">添加</t-button>
      <template #op="scope">
        <b-button @click="editBank(scope.row.id)">编辑</b-button>
        <b-button @click="doDelete(scope.row.id)">删除</b-button>
      </template>
    </page-request>

    <org-bank-edit @success="editSuccess" ref="orgBankEdit"></org-bank-edit>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";
import BButton from "@/components/el/b-button.vue";
import OrgBankEdit from "@org/finance/op/bank-edit.vue";

export default {
  name: "bank-list",
  components: {OrgBankEdit, BButton, TButton, PageRequest, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "userName", label: "开户人"},
        {prop: "type", label: "开户银行"},
        {prop: "name", label: "开户支行"},
        {prop: "bankCode", label: "银行卡号"},
        {label: "是否默认",renderDraw:row=>{return row.isDefault==0?"否": "是";},width: 100}
      ],
      expend: [
        {label: "开户人", prop: "userName"},
        {label: "开户银行", prop: "type"},
        {label: "开户支行", prop: "name"},
        {label: "银行卡号", prop: "bankCode"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    editBank(id){
      this.$refs.orgBankEdit.openDrawer(id);
    },
    doDelete(id){
      this.msgConfirm("/api/mgr/business/shop/money/info/deleteBank", {id: id}, () => {
        this.pageReloadData();
      });
    },
    editSuccess(){
      this.pageReloadData();
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
